import { render, staticRenderFns } from "./Promote.vue?vue&type=template&id=105332fc&"
import script from "./Promote.vue?vue&type=script&lang=js&"
export * from "./Promote.vue?vue&type=script&lang=js&"
import style0 from "./Promote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports